// Configuration utility to switch between demo and production modes
export const config = {
  // Production mode enabled
  isDemoMode: false, // Production mode
  
  // Demo mode settings
  demo: {
    adminEmail: 'admin@demo.com',
    userEmail: 'user@demo.com',
    defaultPassword: 'demo123',
    sampleDomain: 'short.ly'
  },
  
  // Production settings
  production: {
    region: 'us-east-1',
    defaultAdminEmail: process.env.REACT_APP_ADMIN_EMAIL,
    defaultAdminPassword: process.env.REACT_APP_ADMIN_PASSWORD,
    apiEndpoint: process.env.REACT_APP_API_ENDPOINT,
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID
  },
  
  // Feature flags
  features: {
    realTimeAnalytics: true,
    domainVerification: true,
    bulkOperations: true,
    exportData: true,
    customDomains: true
  }
};

export const getMode = () => config.isDemoMode ? 'demo' : 'production';

export const isFeatureEnabled = (feature) => config.features[feature] || false;